import React, { PureComponent, ReactNode } from "react";
import { MusicNoteIdentity, MusicScale } from "../../../wasm/pkg/wasm";
import { ICON_CLOSE } from "../../constants/iconConstants";
import { buildNoteNameMap, ChordInScaleEdit, toNoteNameNoContext, toShortChordNameOverBass } from "../../models/wasm.model";
import IconButton from "../theme_reuse/IconButton";
import { StringsTuning, TablatureSingleChord } from "./InstrumentTypes.model";
import MonoSpacedTextColumn from "./MonoSpacedTextColumn";
import "./StringInstrumentChordTab.css";

interface Props {
  uniqueId: string;
  isSelected: boolean;
  chord: ChordInScaleEdit;
  tab: TablatureSingleChord;
  isTabNumberingRelativeToCapo: boolean;
  capoPosition: number;
  onSelect: () => void;
  onDelete: () => void;
}
interface State {}

/* awkward placement - actually used in guitarneck */
export function toPrintableTabLetterColumn(tuning: StringsTuning, scale: MusicScale): Array<string> {
  const noteNameMap = buildNoteNameMap(scale);

  return tuning.stringsLowToHigh
    .map((s) => s[0])
    .toReversed()
    .map((noteId: MusicNoteIdentity, index) => {
      let letter = noteNameMap[noteId] || toNoteNameNoContext(noteId);
      if (index < 2) {
        letter = letter.toLowerCase();
      }
      return `${letter}-`;
    });
}

export function toPrintableTab(tab: TablatureSingleChord, isTabNumberingRelativeToCapo: boolean, capoPosition: number): Array<string> {
  return tab.stringFretsLowToHigh.toReversed().map((fret) => {
    if (isTabNumberingRelativeToCapo && fret !== "x" && capoPosition !== 0) {
      fret = fret - capoPosition;
    }
    return `--${fret}--`;
  });
}

class StringInstrumentChordTab extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  handleSelect = (_e: React.MouseEvent<any>) => {
    this.props.onSelect();
  };

  handleDeleteTab = () => {
    this.props.onDelete();
  };

  render(): ReactNode {
    const { isSelected, chord, tab, isTabNumberingRelativeToCapo, capoPosition, uniqueId } = this.props;
    const tabAndColumnCss = `string-instr-tab-name-and-column ${isSelected ? "instr-selected-chord" : ""}`;
    const printableTabLines = toPrintableTab(tab, isTabNumberingRelativeToCapo, capoPosition);

    return (
      /* Print tabs in courier new */
      <div className="string-instr-chord-tab-container">
        <div className="string-instr-tab-buttons">
          <IconButton mini icon={ICON_CLOSE} onClick={this.handleDeleteTab} />
        </div>
        <div className={tabAndColumnCss}>
          <div className="instr-chord-summary" onClick={this.props.onSelect}>
            <div className="string-instr-tab-chord-name">{toShortChordNameOverBass(chord)}</div>
          </div>
          <div className="string-instr-tab-column" onClick={this.props.onSelect}>
            <MonoSpacedTextColumn lines={printableTabLines} uniqueId={uniqueId} />
          </div>
        </div>
      </div>
    );
  }
}

export default StringInstrumentChordTab;
